import { getWindowName, WindowNameEnum } from './window';

export const isAddin = (): boolean => getWindowName() === WindowNameEnum.ADDIN;
